import { FoodMenuState } from './foodmenu-reducer';
import { FOOD_MENU_ACTION_TYPE, FoodMenuActions } from './foodmenu-type';

export const foodMenuCreators = {
  setFoodMenuState: <KeyName extends keyof FoodMenuState>(key: KeyName, value: FoodMenuState[KeyName])
    : FoodMenuActions => ({
      type: FOOD_MENU_ACTION_TYPE.SET_FOOD_MENU_STATE,
      payload: { key, value }
    }),
  callFoodMenu: () => ({
    type: FOOD_MENU_ACTION_TYPE.CALL_FOOD_MENU
  })
};
